app.equipeController = app.equipeController || {};

app.equipeController.indexAction = {
    
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.masonry();
        this.avatars();
    },
    
    masonry : function () {
        var $crew = $('.crewList').imagesLoaded( function() {
            $crew.masonry({
                // options
                itemSelector: '.crewItem',
                columnWidth: '.crewItem',
                percentPosition: true
            });
        });
    },
    
    avatars : function () {
        var $avatar = $('.staticAvatar');
        if ($avatar.length > 0) {
            $avatar.each(function(){
                var $this = $(this),
                    $parent = $this.parents('.crewItem'),
                    animatedImg = $this.data('animated'),
                    staticImg = $this.attr('src');
                if (animatedImg) {
                    $parent.hover(
                        function(){
                            $this.attr('src', animatedImg);
                        },
                        function(){
                            $this.attr('src', staticImg);
                        }
                    );
                }
            });
        }
    }

};